<template>
    <div class="my-3 my-lg-6" v-if="shows">
        <v-row class="ma-n1 ma-lg-n3" justify="center">
            <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'" class="pa-1 pa-lg-3" v-if="isAndroidBrowser">
                <a href="https://play.google.com/store/apps/details?id=com.deahanbooks.salerbook" target="_blank">
                    <v-img src="/images/offerwall/download-google.svg" />
                </a>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'" class="pa-1 pa-lg-3" v-if="isIOSBrowser">
                <a href="https://apps.apple.com/kr/app/id1637558375" target="_blank">
                    <v-img src="/images/offerwall/download-apple.svg" />
                </a>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";

export default {
    data: () => ({
        deviceInfo: {},
    }),
    computed: {
        userAgent() {
            return window.navigator.userAgent.toLowerCase();
        },
        isAndroid() {
            return /android/.test(this.userAgent);
        },
        isAndroidBrowser() {
            let isBrowser = this.deviceInfo["x-requested-with"] != "com.deahanbooks.salerbook";
            return this.isAndroid && isBrowser;
        },
        isIOS() {
            return /iphone|ipod|ipad/.test(this.userAgent);
        },
        isIOSBrowser() {
            let isBrowser = /safari/.test(this.userAgent);
            return this.isIOS && isBrowser;
        },
        // isOtherOS() {
        //     return !this.isAndroid && !this.isIOS;
        // },
        shows() {
            // return this.isAndroidBrowser || this.isIOSBrowser || this.isOtherOS;
            return this.isAndroidBrowser || this.isIOSBrowser;
        },
    },
    methods: {
        async init() {
            this.deviceInfo = await api.deviceInfo.get();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
